import getNineBoxIcon from "@icarius-common/nineBoxIcon";

const NineBoxImageRenderer = ({ value }) => {
    if (value === undefined) return null;

    return getNineBoxIcon(value, 24);
};

export default NineBoxImageRenderer;
